/* PhotoTile — shared preview tile used by every photo-based layout in
   SlidePreviewBody (Illustrated hero split, Photo left, Photo top,
   Photo hero, Photo grid). Renders the uploaded image with an optional
   caption overlay, or a graceful SVG placeholder + copy telling the
   founder where to upload a photo. Keeping this in one place stops the
   4 photo layouts drifting apart the next time the placeholder wording
   or icon needs to change.

   Must be rendered inside a parent with `position: relative` and
   `overflow: hidden` — the tile fills its parent with absolute
   positioning so the caller controls the box size.
*/

export default function PhotoTile({
  photo,
  primary,
  iconSize = 46,
  label = "Upload a photo in the Photos section",
  sublabel = "It renders here alongside your headline.",
  captionFontSize = "10px",
}) {
  if (photo) {
    return (
      <>
        <img
          src={photo.url}
          alt={photo.caption || ""}
          className="absolute inset-0 w-full h-full"
          style={{ objectFit: "cover" }}
        />
        {photo.caption && (
          <div
            className="absolute bottom-0 left-0 right-0 px-3 py-1.5"
            style={{
              background: "linear-gradient(to top, rgba(0,0,0,0.65), transparent)",
              color: "#fff",
              fontSize: captionFontSize,
            }}
          >
            {photo.caption}
          </div>
        )}
      </>
    );
  }
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-2">
      <svg viewBox="0 0 60 44" style={{ width: iconSize, opacity: 0.35 }}>
        <rect x="1" y="1" width="58" height="42" rx="3" fill="none" stroke={primary} strokeWidth="1.2" />
        <circle cx="15" cy="14" r="3.5" fill={primary} opacity="0.5" />
        <path d="M 4 40 L 20 24 L 32 34 L 44 20 L 56 40 Z" fill={primary} opacity="0.3" />
      </svg>
      {label && (
        <div className="mt-1.5 text-[10px] font-semibold leading-snug" style={{ color: primary }}>
          {label}
        </div>
      )}
      {sublabel && (
        <div className="text-[9.5px] leading-snug mt-0.5" style={{ color: "#6B7280" }}>
          {sublabel}
        </div>
      )}
    </div>
  );
}
